import Qs from 'qs'
import Cookies from 'js-cookie'
import { cookiesDomain } from '@/utils/token'
import { appCode, isSingleAppDomain } from '@/utils/singleApp'

const urlParse = {
    search: Qs.parse(window?.location?.search || '', { ignoreQueryPrefix: true }),
    init() {
        this._setInviteId()
    },
    /**
     * 设置inviteId，邀约参数，用于注册/登录后的afterlogin，url跳转后也要生效，关闭浏览器再次打开不生效（存在sc/gyl跳到account域的情况，所以存cookie）
     */
    _setInviteId() {
        if (this.search?.inviteId) {
            Cookies.set('__invite_id', this.search.inviteId, {
                domain: cookiesDomain
            })
        }
    },
    /**
     * 获取inviteId
     */
    getInviteId() {
        return Cookies.get('__invite_id')
    },
    /**
     * 设置来源，erp跳转的ffrom，用于注册/登录后的afterlogin，保持7天
     */
    _setSource() {
        if (this.search?.ffrom) {
            Cookies.set('__log_source', this.search.ffrom, {
                expires: 7,
                domain: cookiesDomain
            })
        }
    },
    /**
     * 获取source，如果是市场版就直接取市场版的appCode，主版取ffrom
     */
    getSource() {
        if (isSingleAppDomain) {
            return `MARKET_${appCode}`
        }
        return Cookies.get('__log_source') || ''
    }
}

export default urlParse
